"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breadcrumbsTheme = void 0;

var breadcrumbsTheme = function breadcrumbsTheme(theme) {
  return {
    root: {
      '&.gutter-sm': {
        marginBottom: '1.5rem'
      },
      '&.gutter-md': {
        marginBottom: '2.5rem'
      },
      '&.gutter-lg': {
        marginBottom: '3.5rem'
      }
    },
    ol: {
      color: theme.palette.primary.main
    },
    li: {
      '&:not(:last-child)': {
        marginRight: 8
      },
      '& > a': {
        '&:visited': {
          color: theme.palette.primary.main
        }
      }
    },
    separator: {
      marginLeft: 0
    }
  };
};

exports.breadcrumbsTheme = breadcrumbsTheme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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